import { SearchX } from "lucide-react";
import { Button } from "components/common/buttons/Button";
import { ProjectsEmptyStateProps } from "./ProjectsEmptyState.types";

/** No production matches the search. */
export const ProjectsEmptyState = ({ searchTerm, onClearSearch }: ProjectsEmptyStateProps) => (
  <div className="flex flex-col items-center gap-3 rounded-xl border border-dashed border-border px-4 py-12 text-center">
    <SearchX className="h-6 w-6 text-muted-foreground" aria-hidden />
    <p className="text-sm text-foreground">No production matches “{searchTerm.trim()}”.</p>
    <Button type="button" color="gray" size="sm" onClick={onClearSearch}>
      Clear search
    </Button>
  </div>
);
